import React, { Component } from "react";
import { Link } from "react-router-dom";
import { ROOT } from "../config/config";
import Footer from "./Footer";
import store from "../store";

class ColumnOne extends Component {
  render() {
    return (
      <div className="columnOne">
        {parseInt(store.getState().columnOne.details.user_id) > 0 && (
          <React.Fragment>
            <div>
              {store.getState().columnOne.details.profile_image === "" ? (
                <div
                  className="c1-profile-image img"
                  style={{
                    backgroundImage:
                      "url(" + ROOT + "public/images/profile_pic/avatar.jpg)"
                  }}
                >
                  <img
                    className="img-decoy"
                    alt={store.getState().columnOne.details.username}
                  />
                </div>
              ) : (
                <div
                  className="c1-profile-image img"
                  style={{
                    backgroundImage:
                      "url(" +
                      ROOT +
                      "public/images/profile_pic/" +
                      store.getState().columnOne.details.profile_image +
                      ")"
                  }}
                >
                  <img
                    className="img-decoy"
                    alt={store.getState().columnOne.details.username}
                  />
                </div>
              )}

              <Link
                to={`/user/${store
                  .getState()
                  .columnOne.details.username.replace(/ /g, "-")}-${
                  store.getState().columnOne.details.user_id
                }`}
              >
                <p className="c1-username pull-left">
                  {store.getState().columnOne.details.username}
                </p>
              </Link>
              <div className="clear-float" />
            </div>

            <div className="c1-user-options">
              <Link
                to={`/user/${store
                  .getState()
                  .columnOne.details.username.replace(/ /g, "-")}-${
                  store.getState().columnOne.details.user_id
                }/`}
              >
                <p className="c1-user-post-count">
                  Posts{" "}
                  <span>{store.getState().columnOne.details.post_count}</span>
                </p>
              </Link>
            </div>

            <div className="c1-user-options">
              <Link
                to={`/user/${store
                  .getState()
                  .columnOne.details.username.replace(/ /g, "-")}-${
                  store.getState().columnOne.details.user_id
                }/bookmark`}
              >
                <p className="c1-bookmark-count">
                  Bookmarks{" "}
                  <span>
                    {store.getState().columnOne.details.bookmark_count}
                  </span>
                </p>
              </Link>
            </div>
          </React.Fragment>
        )}

        {parseInt(store.getState().columnOne.details.user_id) < 1 && (
          <h2
            style={{
              textAlign: "center",
              color: "#525252",
              marginTop: 150 + "px"
            }}
          >
            Please Login
          </h2>
        )}

        <Footer />
      </div>
    );
  }
}

export default ColumnOne;
